function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-345 -151.81)"
}, /*#__PURE__*/React.createElement("line", {
  x2: 17.49,
  transform: "translate(349 155.81)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x2: 17.49,
  transform: "translate(386.5 155.81)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x2: 17.49,
  transform: "translate(424.5 155.81)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x2: 17.49,
  transform: "translate(447.5 208.81)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x2: 17.49,
  transform: "translate(410 208.81)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x2: 17.49,
  transform: "translate(373 208.81)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x2: 3.99,
  transform: "translate(349.5 208.81)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x2: 2,
  transform: "translate(462.5 155.81)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x2: 17.49,
  transform: "translate(465.245 156.065) rotate(90)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x2: 17.49,
  transform: "translate(349.245 191.065) rotate(90)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  y2: 14.055,
  transform: "translate(349.245 157.5)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("line", {
  x2: 0.255,
  y2: 14.93,
  transform: "translate(465.245 193.57)",
  fill: "none",
  stroke: "#313131",
  strokeLinecap: "round",
  strokeWidth: 8
}));

var SvgBoxDashed = function SvgBoxDashed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124.568,
    height: 61,
    viewBox: "0 0 124.568 61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoxDashed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/box-dashed.20dcf941.svg";
export { ForwardRef as ReactComponent };